import { render, staticRenderFns } from "./UpdatePostalMatter.vue?vue&type=template&id=fd6bbdc6"
import script from "./UpdatePostalMatter.vue?vue&type=script&lang=js"
export * from "./UpdatePostalMatter.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports